import { Input } from "@/components/ui/input";
import { tl, orderTotals } from "@/lib/fair";

const pctCls = "h-10 w-24 text-center font-mono bg-[#EFE6D6] border-[#DCCFB8]";

// Discount/VAT inputs + subtotal → grand total breakdown
export default function FairTotals({ rows, discount, vat, onDiscount, onVat }) {
  const t = orderTotals({ items: rows, discount_pct: discount, vat_pct: vat });
  const line = (label, value, testId, strong) => (
    <div className={`flex justify-between gap-6 ${strong ? "text-base font-bold text-[#B45309] border-t border-[#DCCFB8] pt-1.5" : "text-sm"}`}>
      <span className="text-[#6B5B4A]">{label}</span><span className="font-mono" data-testid={testId}>{value}</span>
    </div>
  );
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 rounded-md border border-[#DCCFB8] bg-[#FFFBF4] p-3" data-testid="fair-totals">
      <div className="flex gap-3">
        <label className="text-[10px] font-mono uppercase text-[#6B5B4A]">İskonto %
          <Input type="number" min={0} max={100} step="0.01" value={discount} onChange={(e) => onDiscount(e.target.value)}
            data-testid="fair-order-discount" className={pctCls} /></label>
        <label className="text-[10px] font-mono uppercase text-[#6B5B4A]">KDV %
          <Input type="number" min={0} max={100} step="0.01" value={vat} onChange={(e) => onVat(e.target.value)}
            data-testid="fair-order-vat" className={pctCls} /></label>
      </div>
      <div className="min-w-[260px] space-y-0.5">
        {line("Ara Toplam", tl(t.subtotal), "fair-order-subtotal")}
        {line(`İskonto (%${Number(discount) || 0})`, `− ${tl(t.discount)}`, "fair-order-discount-amount")}
        {line(`KDV (%${Number(vat) || 0})`, tl(t.vat), "fair-order-vat-amount")}
        {line("Genel Toplam", tl(t.grand), "fair-order-grand", true)}
      </div>
    </div>
  );
}
